/// <reference path="../../../components/commonClasses/commonSectionBase.ts" />

module Meevo.Plugins.AdpIntegration {
    "use strict";

    /**
    * Main Section of Field Labels
    */
    export class CommissionSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        protected excludePayrollInputTypes: any[]=[];
        protected payrollInputTypeEnumList: any[] = [];
        private compensationDataService: Meevo.Components.CommonClasses.IADPIntegrationService;
        private compensationSettingsEndPoint: string;
        protected busyService: Components.Busy.IBusyService;

        public overtimeTypeAdvanced: boolean;

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            protected $translate: angular.translate.ITranslateService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            busyService: Components.Busy.IBusyService,
            compensationSettingsEndPoint: string,
            sectionSecurityKey?: string,
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                noun,
                identityService,
                sectionSecurityKey);
            this.compensationSettingsEndPoint = compensationSettingsEndPoint;
            this.compensationDataService = this.dataService as Meevo.Components.CommonClasses.IADPIntegrationService;
            this.busyService = busyService;
            this.getPayrollInputEnumList();
            this.getPayrollCommissionDetails();
        }

        activate(): void {
            super.activate();
            
        }
        
        getPayrollCommissionDetails(): void {
            this.compensationDataService.getCompensationSettings(this.compensationSettingsEndPoint).then((res: Model.CompensationSettings) => { this.overtimeTypeAdvanced = res.overtimeTypeEnum == Meevo.Model.OvertimeTypeEnum.Advanced; });
        }

        getPayrollInputEnumList(): void {
            let refEnumType: Model.EnumTypeEnum = Model.EnumTypeEnum["PayrollInputTypesEnum"];

            this.dataService.getEnumList(refEnumType)
                .then((data: any) => {

                    if (this.excludePayrollInputTypes) {
                        for (var i = 0; i < this.excludePayrollInputTypes.length; i++) {
                            data = _.without(data, _.findWhere(data, { id: this.excludePayrollInputTypes[i] }));
                        }
                    }

                    this.payrollInputTypeEnumList= data;
                });


        }
        updateAdpCommissions(): void {
            this.busyService.start();
            this.model = this.dataService.getSection(this.baseEndpoint, "RefreshEarningCodes")
                .then((data: any) => {
                    this.model = data;

                }).finally(() => {
                    this.busyService.stop();

                   this.modalService.info(this.$translate.instant('LABEL_ADP_INFO_EARNING_CODES_RECIEVED', {
                        number: this.model.adpEarningCodeList.length
                    }));
                });
        }

        setPayrollInputEnum(item: any) {
           
            if (item !== undefined) {
                this.excludePayrollInputTypes.push(item);
            }
        }

    }
}